var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProposals(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.625 1.9375V3.625H12.375V1.9375C12.375 1.65625 12.0938 1.375 11.8125 1.375H6.1875C5.87109 1.375 5.625 1.65625 5.625 1.9375ZM4.5 3.625V1.9375C4.5 1.02344 5.23828 0.25 6.1875 0.25H11.8125C12.7266 0.25 13.5 1.02344 13.5 1.9375V3.625H15.75C16.9805 3.625 18 4.64453 18 5.875V14.875C18 16.1406 16.9805 17.125 15.75 17.125H2.25C0.984375 17.125 0 16.1406 0 14.875V5.875C0 4.64453 0.984375 3.625 2.25 3.625H4.5ZM12.9375 4.75H5.0625H2.25C1.61719 4.75 1.125 5.27734 1.125 5.875V9.25H6.1875H7.3125H10.6875H11.8125H16.875V5.875C16.875 5.27734 16.3477 4.75 15.75 4.75H12.9375ZM16.875 10.375H11.8125V12.0625C11.8125 12.6953 11.2852 13.1875 10.6875 13.1875H7.3125C6.67969 13.1875 6.1875 12.6953 6.1875 12.0625V10.375H1.125V14.875C1.125 15.5078 1.61719 16 2.25 16H15.75C16.3477 16 16.875 15.5078 16.875 14.875V10.375ZM7.3125 10.375V12.0625H10.6875V10.375H7.3125Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProposals);
export default __webpack_public_path__ + "static/media/proposals.29a14b78b857d81dbcb746361992c122.svg";
export { ForwardRef as ReactComponent };